import { ProjectMilestoneStatusActions } from "@/enums";
import { Modal } from "antd";
import { bool, func, shape, string } from "prop-types";
import { useIntl } from "react-intl";

export const MilestoneStatusConfirmModal = ({
  modalState,
  handleOk,
  handleCancel,
}) => {
  const intl = useIntl();
  return (
    <Modal
      open={modalState.visible}
      onOk={() => {
        handleOk();
      }}
      onCancel={() => {
        handleCancel();
      }}
      okText={intl.formatMessage({
        id: "milestoneCompleteModal.continue",
      })}
      title={intl.formatMessage({ id: "milestoneCompleteModal.title" })}
    >
      {intl.formatMessage({
        id:
          modalState.action === ProjectMilestoneStatusActions.SubmitForApproval
            ? "milestoneCompleteModal.submitForApproval"
            : "milestoneCompleteModal.content",
      })}
    </Modal>
  );
};
MilestoneStatusConfirmModal.propTypes = {
  modalState: shape({
    visible: bool,
    action: string,
  }).isRequired,
  handleOk: func.isRequired,
  handleCancel: func.isRequired,
};
